export const environment = {
  production: false,
  appName: 'RMS_POS_V2',
  apiUrl: 'https://adminlayers.crescenterp.website/v2/api/pos/',
  oldApiUrl: 'https://adminlayers.crescenterp.website/api/',
  // apiUrl: 'https://dev-admin.cherryberrycloud.com/v2/api/pos/',
  // oldApiUrl: 'https://dev-admin.cherryberrycloud.com/api/',
  googleMapsApiKey: 'AIzaSyC9kxyEL5d23i4Kr4QbI8W4OT9M9_5e7ps',
  firebase: {
    apiKey: "AIzaSyA3KsN3KekyE7CUvuIqHVFdtiOINZqhdmE",
    authDomain: "deliveryboyapp-8a010.firebaseapp.com",
    databaseURL: "https://deliveryboyapp-8a010.firebaseio.com",
    projectId: "deliveryboyapp-8a010",
    storageBucket: "deliveryboyapp-8a010.firebasestorage.app",
    messagingSenderId: "360421726462",
    appId: "1:360421726462:web:20e4056d1a528caa90adaf",
    measurementId: "G-Y8Q8KNHNH0"
  }
};
